import React from 'react';
import { clientLogos } from '../../data/clientLogos';
import { inkMatrix, logoFilterId } from '../../utils/logoSizing';
import type { LogoInkMode } from '../../types/logos';
type FilterSpec = {
  id: string;
  mode: LogoInkMode;
  slope: number;
  intercept: number;
  color: string;
  fallback: string;
};
const LOGO_FILTERS: FilterSpec[] = clientLogos.map(l => ({
  id: logoFilterId(l.id),
  mode: l.mode,
  slope: l.slope,
  intercept: l.intercept,
  color: 'rgb(var(--ridge))',
  fallback: '#465A69'
}));
const ICON_FILTERS: FilterSpec[] = [{
  id: 'icon-filter-mist',
  mode: 'dark',
  slope: 2,
  intercept: -0.2,
  color: 'rgb(var(--mist))',
  fallback: '#8D9CA5'
}, {
  id: 'icon-filter-paper',
  mode: 'dark',
  slope: 2,
  intercept: -0.2,
  color: 'rgb(var(--paper))',
  fallback: '#F6F5F1'
},
// Brand-blue icon on Paper: blue becomes the token, the white "in" stays cut out.
{
  id: 'icon-filter-ridge',
  mode: 'dark',
  slope: 3,
  intercept: -0.5,
  color: 'rgb(var(--ridge))',
  fallback: '#465A69'
}, {
  id: 'icon-filter-ink',
  mode: 'dark',
  slope: 3,
  intercept: -0.5,
  color: 'rgb(var(--ink))',
  fallback: '#1C2834'
}];

/**
 * Flattens supplied artwork to a single token color without redrawing it:
 * extract ink (from luminance or alpha), mask by source alpha, threshold, then flood.
 */
export function LogoFilters() {
  return <svg aria-hidden="true" focusable="false" width="0" height="0" style={{
    position: 'absolute',
    width: 0,
    height: 0
  }} data-id="element-11" data-mp="2ai0iqe75ubra">
      <defs data-id="element-12" data-mp="2y7ldrvgl8zgx">
        {[...LOGO_FILTERS, ...ICON_FILTERS].map(f => <filter key={f.id} id={f.id} x="0" y="0" width="1" height="1" colorInterpolationFilters="sRGB" data-id="element-13" data-mp="334v3zdbsxf5t">
            <feColorMatrix in="SourceGraphic" type="matrix" values={inkMatrix(f.mode)} result="ink" data-id="element-14" data-mp="2og79zbhltdhz" />
            {f.mode === 'alpha' ? null : <feComposite in="ink" in2="SourceGraphic" operator="in" result="masked" data-id="element-15" data-mp="2te0gy6qqebjb" />}
            <feComponentTransfer in={f.mode === 'alpha' ? 'ink' : 'masked'} result="shape" data-id="element-16" data-mp="3h4cvi0ghf6iv">
              <feFuncA type="linear" slope={f.slope} intercept={f.intercept} data-id="element-17" data-mp="3lxp636obtcsm" />
            </feComponentTransfer>
            <feFlood floodColor={f.fallback} style={{
          floodColor: f.color
        }} result="tone" data-id="element-18" data-mp="3vqa6tcjguo90" />
            <feComposite in="tone" in2="shape" operator="in" data-id="element-19" data-mp="3qu2wz8ny8sls" />
          </filter>)}
      </defs>
    </svg>;
}